import { useState } from "react";
import { BellRing, Clock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const CartAlert = ({ p, held, onChange }) => {
  const [busy, setBusy] = useState(false);
  if (p.login_required) return null;
  if (p.held_for_you) {
    const until = new Date(p.held_for_you).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
    return (
      <p className="mt-3 flex items-center gap-2 rounded-xl border-2 border-teal-600 bg-teal-50 px-4 py-3 text-sm text-teal-900" data-testid="held-for-you">
        <Clock className="h-4 w-4 shrink-0" />È tornato disponibile ed è riservato per te fino alle <b>{until}</b>: aggiungilo al carrello.
      </p>
    );
  }
  if (!held) return null;
  const toggle = async () => {
    setBusy(true);
    try {
      if (p.alert_subscribed) {
        await api.delete(`/cart-alerts/${p.id}`);
        toast.success("Avviso annullato");
      } else {
        const { data } = await api.post(`/cart-alerts/${p.id}`);
        toast.success(data.position === 1 ? "Sei il primo in coda: se si libera te lo riserviamo per 30 minuti" : `Sei il numero ${data.position} in coda`);
      }
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3" data-testid="cart-alert">
      <button onClick={toggle} disabled={busy} data-testid={p.alert_subscribed ? "cart-alert-cancel" : "cart-alert-subscribe"}
        className={`flex items-center gap-2 rounded-full px-5 py-2 text-sm font-bold disabled:opacity-50 ${p.alert_subscribed ? "border-2 border-black/20 text-stone-700" : "bg-black text-white"}`}>
        <BellRing className="h-4 w-4" />{p.alert_subscribed ? "Annulla avviso" : "Avvisami"}
      </button>
      <span className="text-xs text-stone-600">{p.alert_subscribed ? "Sei in coda: se si libera te lo riserviamo per 30 minuti e ti mandiamo un'email." : "Se si libera lo riserviamo per 30 minuti al primo in coda."}</span>
    </div>
  );
};
